<ng-container *ngIf="state === 'form'">
  <h2 mat-dialog-title class="reservation-dialog__title">
    {{ !numeroReserva ? 'Reserva Manual' : 'Editar Número de Reserva' }}
  </h2>

  <mat-dialog-content class="reservation-dialog__body">
    <section *ngIf="!numeroReserva" class="reservation-dialog__status-tabs">
      <button
        type="button"
        *ngFor="let option of reservationOptions"
        class="reservation-dialog__status-tab"
        [class.reservation-dialog__status-tab--active]="selectCheckBox === option.value"
        (click)="changeCheckBox(option.value)"
      >
        {{ option.label }}
      </button>
    </section>

    <ng-container *ngIf="selectCheckBox === OrderReservationStatus.CONFIRMADO">
      <p class="reservation-dialog__label">Ingrese el código de reserva:</p>
      <input
        class="reservation-dialog__input"
        [formControl]="codigoControl"
        type="text"
        placeholder="Código de reserva"
        autocomplete="off"
      />
      <p
        *ngIf="codigoControl.invalid && codigoControl.touched"
        class="reservation-dialog__error"
      >
        Solo se permiten letras, números y caracteres permitidos.
      </p>
    </ng-container>

    <p *ngIf="message" class="reservation-dialog__hint">{{ message }}</p>
  </mat-dialog-content>

  <mat-dialog-actions align="center" class="reservation-dialog__actions">
    <button
      mat-flat-button
      class="buttonPrimary"
      (click)="saveReserva()"
      [disabled]="isLoading"
    >
      <mat-spinner *ngIf="isLoading" [diameter]="18"></mat-spinner>
      <span *ngIf="!isLoading">Guardar</span>
    </button>
  </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="state === 'error'">
  <h2 mat-dialog-title class="reservation-dialog__title">
    {{ errorTitle || 'No se pudo actualizar' }}
  </h2>

  <mat-dialog-content class="reservation-dialog__body">
    <p class="reservation-dialog__error">{{ errorMessage }}</p>
    <p class="reservation-dialog__hint">
      La grilla puede estar desactualizada. Al continuar se consultará de nuevo el backend.
    </p>
  </mat-dialog-content>

  <mat-dialog-actions align="center" class="reservation-dialog__actions">
    <button
      mat-flat-button
      class="buttonPrimary"
      (click)="cerrarYActualizar()"
    >
      Entendido y actualizar
    </button>
  </mat-dialog-actions>
</ng-container>
